"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineNo = exports.Pre = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  text-align: center;

`;
exports.Pre = styled_components_1.default.pre `
  font-family: 'Source Code Pro', monospace !important;
  background: #35495e !important;
  text-align: left;
  margin: 1em 0;
  padding: 2.5em;
  border-radius: 5px;
  
  & .token-line {
    line-height: 1.3em;
    height: 1.6em;
  }
`;
exports.LineNo = styled_components_1.default.span `
  display: inline-block;
  width: 2em;
  user-select: none;
  opacity: 0.3;
`;
